<template>
  <hm-content title="">
    <div class="mb20 flex flex-between">
      <div>
        <el-radio-group
          v-model="searchCondition.status"
          size="small"
          @change="switchTab"
        >
          <el-radio-button label="zuZhi">组织架构</el-radio-button>
          <el-radio-button label="jueSe">角色管理</el-radio-button>
          <el-radio-button label="zhiYuan">职员管理</el-radio-button>
          <el-radio-button label="weiHu">角色维护</el-radio-button>
          <el-radio-button label="shenPi">审批配置</el-radio-button>
        </el-radio-group>
      </div>
      <div>
        当前供货商: <span class="primary">{{ storeName }}</span>
      </div>
    </div>
    <div class="table" v-if="searchCondition.status === 'zuZhi'">
      <div class="table-panel flex flex-between">
        <div>
          <el-button type="primary" size="small" @click="addOrganization"
          >新建机构</el-button>
          <el-button
              type="success"
              size="small"
              @click="output1"
              :loading="isOutputing"
          >导出</el-button>
        </div>
        <div>
          <el-input
            clearable
            v-model.trim="keyWords"
            placeholder="输入机构名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>

      <el-table
        :data="organizationList.records"
        stripe
        lazy
        :load="load"
        style="width: 100%"
        size="small"
        @sort-change="sortChange"
        row-key="id"
        border
        v-if="resetForm2"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="编号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          prop="departName"
          label="机构全名"
          header-align="center"
        >
        </el-table-column>
        <el-table-column
          prop="orgCode"
          label="机构编号"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="机构电话"
          header-align="center"
          align="center"
        >
        </el-table-column>
         <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <button
                  class="pointer mr10 no-bg"
                  @click="edit(scope.row, searchCondition.status)"
                >
                  <span class="hmicon icon-bianji blue"></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="organizationList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100, 200]"
          layout="total,  prev, pager, next, jumper, sizes"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        :title="title"
        :visible.sync="dialogVisible"
      >
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="机构编号" prop="orgCode">
            <el-input
              :disabled="disabled"
              clearable
              v-model="ruleForm.orgCode"
              maxlength="20"
              size="small"
              placeholder="请输入单行文本，限制20个字符"
            ></el-input>
            <!-- <div class="form-item-tip">
            编号为唯一值，仅支持英文和数字，不支持其他符号
          </div> -->
          </el-form-item>

          <el-form-item label="上级机构" prop="parentId">
            <el-cascader
              clearable
              ref="cascader"
              v-model="ruleForm.parentId"
              :props="props"
              :show-all-levels="false"
              v-if="dialogVisible"
              size="small"
            ></el-cascader>
            <!-- <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
          </el-form-item>
          <el-form-item label="机构全名" prop="departName">
            <el-input
              clearable
              v-model.trim="ruleForm.departName"
              maxlength="50"
              style="width: 460px"
              size="small"
              placeholder="请输入机构全名"
            ></el-input>
          </el-form-item>
          <el-form-item label="机构电话" prop="mobile">
            <el-input
              clearable
              type="number"
              v-model="ruleForm.mobile"
              maxlength="20"
              size="small"
              placeholder="请输入机构电话"
            ></el-input>
          </el-form-item>

          <el-form-item label="备注" prop="description">
            <el-input
              clearable
              style="width:300px"
              type="textarea"
              v-model="ruleForm.description"
              maxlength="20"
              size="small"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="btn-wrapper flex flex-center">
          <el-button
            size="small"
            type="primary"
            @click="save"
            >确 定</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="table" v-if="searchCondition.status === 'jueSe'">
      <div class="table-panel">
        <div>
          <el-input
            clearable
            v-model.trim="roleName"
            placeholder="请输入角色名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-date-picker
            class="mr10"
            v-model="createTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="创建开始日期"
            end-placeholder="创建结束日期"
            :default-time="['00:00:00', '23:59:59']"
            size="small"
          ></el-date-picker>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table-panel">
        <el-button type="primary" plain size="small" @click="handleAdd"
          >新增</el-button
        >
        <el-button
          type="success"
          plain
          size="small"
          @click="output(allRoleUserList, 'roleTable', '角色列表')"
          >导出</el-button
        >
        <!-- <el-button type="primary" plain size="small" @click="importExcel"
        >导入</el-button
      >-->
      </div>
      <div class="table">
        <el-table
          stripe
          ref="roleTable"
          :data="roleList.records"
          style="width: 100%"
          id="table"
          size="small"
          border
          v-if="resetForm2"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="roleName"
            label="角色名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="roleCode"
            label="角色编码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            show-overflow-tooltip
            align="center"
            prop="description"
            label="备注"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="创建时间"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="updateTime"
            label="更新时间"
          ></el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-tooltip class="item" content="编辑" placement="top">
                  <div
                    class="pointer mr10"
                    @click="edit(scope.row, searchCondition.status)"
                  >
                    <span class="hmicon icon-bianji blue"></span>
                  </div>
                </el-tooltip>
                <el-tooltip class="item" content="授权" placement="top">
                  <div
                    class="pointer mr10"
                    @click="openAuthorizeDialog(scope.row)"
                  >
                    <span class="hmicon icon-xingzhuanggaizhang blue"></span>
                  </div>
                </el-tooltip>
                <el-tooltip class="item" content="删除" placement="top">
                  <div class="pointer mr10" @click="remove(scope.row)">
                    <span class="hmicon icon-shanchu primary"></span>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="roleList.total"
          @current-change="paging"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <el-dialog
        :title="mode === 'add' ? '新增' : '编辑'"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        width="800px"
        @close="resetForm('ruleForm')"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="large-label-form"
        >
          <el-form-item label="角色名称：" prop="roleName">
            <el-input
              size="small"
              clearable
              v-model.trim="ruleForm.roleName"
            ></el-input>
          </el-form-item>
          <el-form-item label="角色编码：" prop="roleCode">
            <el-input
              size="small"
              :disabled="mode === 'edit'"
              clearable
              v-model.trim="ruleForm.roleCode"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="description">
            <el-input
              size="small"
              clearable
              type="textarea"
              v-model.trim="ruleForm.description"
            ></el-input>
          </el-form-item>
          <div class="flex flex-center">
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
              >提交</el-button
            >
            <el-button size="small" @click="resetForm('ruleForm')"
              >返回</el-button
            >
          </div>
        </el-form>
      </el-dialog>
      <el-drawer
        custom-class="hm-drawer"
        :wrapperClosable="false"
        title="角色权限配置"
        :visible="authorizeDialogVisible"
        direction="rtl"
        :before-close="handleClose"
      >
        <div class="drawer-content">
          <div class="caption">所拥有的权限：</div>
          <el-tree
            :data="roleTreeList"
            empty-text="暂无权限"
            :props="propsTree"
            node-key="value"
            default-expand-all
            ref="tree"
            highlight-current
            show-checkbox
          ></el-tree>
        </div>
        <div class="drawer-footer flex flex-between item-center">
          <div>
            <el-dropdown trigger="click" @command="selectItem">
              <span class="el-dropdown-link flex item-center">
                树操作
                <i class="el-icon-arrow-up el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checkAll">全部勾选</el-dropdown-item>
                <el-dropdown-item command="cancleCheckAll"
                  >取消全选</el-dropdown-item
                >
                <el-dropdown-item command="openAll">展开所有</el-dropdown-item>
                <el-dropdown-item command="cancleOpenAll"
                  >合并所有</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div>
            <el-button type="primary" size="small" @click="savePermission"
              >保存</el-button
            >
            <el-button size="small" @click="authorizeDialogVisible = false"
              >返回</el-button
            >
          </div>
        </div>
      </el-drawer>
    </div>
    <div class="table" v-if="searchCondition.status === 'zhiYuan'">
      <div class="table-panel flex flex-between">
        <div>
          <el-button type="primary" size="small" @click="addEmployee"
            >添加职员</el-button
          >
          <el-button
              type="success"
              size="small"
              @click="output1"
              :loading="isOutputing"
          >导出</el-button>
        </div>
        <div>
          <el-input
            clearable
            style="width:200px"
            v-model.trim="keyWords"
            placeholder="请输入账户/用户/手机号/工号"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-cascader
            clearable
            style="marginRight:10px"
            ref="cascader"
            v-model="orgCode"
            :props="propsprops"
            :show-all-levels="false"
            size="small"
            placeholder="请选择机构"
          ></el-cascader>
          <el-select
            clearable
            style="marginRight:10px"
            size="small"
            v-model="workingState"
            placeholder="请选择在职状态"
          >
            <el-option label="在职" value="yes"> </el-option>
            <el-option label="离职" value="no"> </el-option>
          </el-select>
          <el-select
            clearable
            style="marginRight:10px"
            size="small"
            v-model="syncFlag"
            placeholder="请选择是否同步"
          >
            <el-option label="同步" value="erp"> </el-option>
            <el-option label="非同步" value="hemiao"> </el-option>
          </el-select>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="flex item-center">
        <div @click="outputExcel" class="delete ml20 mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出职员模板
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入职员
          <input
              type="file"
              @change="importf"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          上传表格修改职员组织
          <input
              type="file"
              @change="importf1"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div>
      <el-table
        :data="allEmployeeList.records"
        stripe
        border
        lazy
        style="width: 100%"
        size="small"
        v-if="resetForm2"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          prop="username"
          label="用户账号"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="realname"
          label="用户名称"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="workNum"
          label="工号"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.workNum }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="departName"
          label="所属机构"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="isManager"
          label="是否主管"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.isManager === "yes" ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="workingState"
          label="状态"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.workingState === 'yes'">在职</span>
            <span v-if="scope.row.workingState === 'no'">离职</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="syncFlag"
          label="同步状态"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.syncFlag === "erp" ? "同步" : "非同步" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <button
                  class="pointer mr10 no-bg"
                  @click="edit(scope.row, searchCondition.status)"
                >
                  <span class="hmicon icon-bianji blue"></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="allEmployeeList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100, 200]"
          layout="total,  prev, pager, next, jumper, sizes"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <el-dialog :visible.sync="errEmployeeVisible" width="60%" title="导入失败提示">
        <div slot="title">
        <span style="font-size: 18px; color: #303133"
        >导入失败提示</span
        >
        </div>
        <div>
          <div class="flex flex-between">
            <div class="flex item-center">
              您有
              <span class="error">{{ errEmployeeList.length }}</span
              >条数据导入失败
              <div @click="outputEmployeeErrExcel" class="delete pointer ml10">
                <span class="delete-icon hmicon icon-daochu"></span>
                导出失败数据
              </div>
            </div>
            <div>
              您有
              <span class="success"> {{ succEmployeeList.length }}</span
              >条数据导入成功！
            </div>
          </div>

          <el-table :data="errEmployeeList" border class="small-table mt10">
            <el-table-column
                header-align="center"
                align="center"
                prop="username"
                label="用户账号"></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="realname"
                label="用户名字"></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="workNum"
                label="工号"></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="phone"
                label="手机号"></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="refuseReason"
                label="失败原因"
            ></el-table-column>
          </el-table>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="errEmployeeVisible1" width="60%" title="导入失败提示">
        <div slot="title">
        <span style="font-size: 18px; color: #303133"
        >导入失败提示</span
        >
        </div>
        <div>
          <div class="flex flex-between">
            <div class="flex item-center">
              您有
              <span class="error">{{ errEmployeeList1.length }}</span
              >条数据导入失败
              <div @click="outputEmployeeErrExcel1" class="delete pointer ml10">
                <span class="delete-icon hmicon icon-daochu"></span>
                导出失败数据
              </div>
            </div>
          </div>

          <el-table :data="errEmployeeList1" border class="small-table mt10">
            <el-table-column
                header-align="center"
                align="center"
                prop="username"
                label="用户账号"></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="orgCode"
                label="机构编码"></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="error"
                label="失败原因"
            ></el-table-column>
          </el-table>
        </div>
      </el-dialog>
      <el-dialog
        :close-on-click-modal="false"
        :title="title"
        :visible.sync="dialogVisible"
        @close="resetForm('ruleForm')"
      >
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="用户账号" prop="username">
            <el-input
              clearable
              :disabled="title === '编辑用户'"
              v-model.trim="ruleForm.username"
              maxlength="20"
              size="small"
              placeholder="请输入用户账号（20文本内）"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户密码" prop="password">
            <el-input
              clearable
              autocomplete="new-password"
              v-model.trim="ruleForm.password"
              maxlength="20"
              type="password"
              size="small"
              placeholder="请输入用户密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmpassword">
            <el-input
              clearable
              type="password"
              autocomplete="new-password"
              v-model.trim="ruleForm.confirmpassword"
              maxlength="20"
              size="small"
              placeholder="请确认输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名字" prop="realname">
            <el-input
              clearable
              v-model.trim="ruleForm.realname"
              maxlength="20"
              size="small"
              placeholder="请输入用户名字"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属机构" prop="orgCodes">
            <el-cascader
              ref="cascader"
              clearable
              v-model="ruleForm.orgCodes"
              :props="propsprops"
              :show-all-levels="false"
              size="small"
            ></el-cascader>
          </el-form-item>

          <el-form-item label="角色分配" prop="ruleLists">
            <el-select
              v-model="ruleForm.ruleLists"
              value-key="id"
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="(item, i) in roleLists"
                :key="i"
                :label="item.roleName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="工号" prop="workNum">
            <el-input
              :disabled="disabled"
              maxlength="8"
              clearable
              @input="filterGt0OrFixed2('workNum')"
              v-model.trim="ruleForm.workNum"
              size="small"
              placeholder="请输入工号"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input
              clearable
              v-model.trim="ruleForm.phone"
              size="small"
              type="number"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="在职状态" prop="workingState">
            <el-select
              v-model="ruleForm.workingState"
              placeholder="请选择在职状态"
            >
              <el-option label="在职" value="yes"> </el-option>
              <el-option label="离职" value="no"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否主管" prop="isManager">
            <el-select
              v-model="ruleForm.isManager"
              placeholder="请选择是否主管"
            >
              <el-option label="是" value="yes"> </el-option>
              <el-option label="否" value="no"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="管理品牌" prop="brandRelList">
            <el-select
              clearable
              size="small"
              class="mr10"
              v-model="ruleForm.brandRelList"
              filterable
              multiple
              placeholder="商品品牌,不选则表示全部"
            >
              <!-- <el-option label="全部" value="all"></el-option> -->
              <el-option
                :label="v.brandName"
                :value="v.hemiaoBrandId"
                v-for="(v, i) in allHemiaoBrandBoxList"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select v-model="ruleForm.sex" placeholder="请选择性别">
              <el-option label="男" value="1"> </el-option>
              <el-option label="女" value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入职时间" prop="regDay">
            <el-date-picker
              v-model="ruleForm.regDay"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="生日" prop="birthday">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="ruleForm.birthday"
              type="date"
              placeholder="请选择时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input
              clearable
              v-model.trim="ruleForm.address"
              maxlength="99"
              size="small"
              placeholder="请输入地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="context">
            <el-input
              clearable
              v-model.trim="ruleForm.context"
              maxlength="99"
              size="small"
              placeholder="请输入备注文本"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="btn-wrapper flex flex-center">
          <el-button size="small" type="primary" @click="saves"
            >确 定</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="table" v-if="searchCondition.status === 'weiHu'">
      <div class="flex flex-between">
        <div class="flex-1 mr10" :class="{ w50: isShowDetail }">
          <div class="table-panel">
            <div>
              <el-input
                clearable
                v-model.trim="roleName"
                placeholder="请输入角色名称"
                size="small"
                class="ipt mr10"
              ></el-input>
              <el-button type="primary" size="small" @click="search"
                >查询</el-button
              >
            </div>
          </div>
          <div class="table-panel">
            <el-button type="primary" plain size="small" @click="handleAdd"
              >角色录入</el-button
            >
            <!-- <el-button type="primary" plain size="small" @click="importExcel"
            >导入</el-button
          >-->
            <el-button
              type="success"
              plain
              size="small"
              @click="output(roleUserList, 'roleTable', '角色列表')"
              >导出</el-button
            >
          </div>
          <div class="table">
            <el-table
              stripe
              ref="roleTable"
              :data="roleList.records"
              style="width: 100%"
              id="table"
              size="small"
              border
              v-if="resetForm2"
            >
              <el-table-column
                type="index"
                label="序号"
                :index="index => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="roleCode"
                label="角色编码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="roleName"
                label="角色名称"
              ></el-table-column>
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-tooltip class="item" content="详情" placement="top">
                      <div class="pointer mr10" @click="showDetails(scope.row)">
                        <span class="hmicon icon-chakan blue"></span>
                      </div>
                    </el-tooltip>
                    <el-tooltip class="item" content="编辑" placement="top">
                      <div
                        class="pointer mr10"
                        @click="edit(scope.row, searchCondition.status)"
                      >
                        <span class="hmicon icon-bianji blue"></span>
                      </div>
                    </el-tooltip>
                    <el-tooltip class="item" content="删除" placement="top">
                      <div class="pointer mr10" @click="removes(scope.row)">
                        <span class="hmicon icon-shanchu primary"></span>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="roleList.total"
              @current-change="paging"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPage"
            ></el-pagination>
          </div>
        </div>
        <div
          class="flex-1"
          :class="{ w50: isShowDetail }"
          v-show="isShowDetail"
        >
          <div class="table-panel flex">
            <el-input
              clearable
              v-model.trim="username"
              placeholder="请输入用户账号"
              size="small"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="searchDetails"
              >查询</el-button
            >
          </div>
          <div class="table-panel">
            <!-- <el-button type="primary" plain size="small" @click="userEntry"
              >用户录入</el-button
            > -->
            <el-button type="primary" plain size="small" @click="addExsistdUser"
              >添加已有用户</el-button
            >
          </div>
          <div class="table">
            <el-table
              stripe
              :data="roleUserList.records"
              style="width: 100%"
              id="table"
              size="small"
              border
            >
              <el-table-column
                type="index"
                label="序号"
                :index="
                  index =>
                    index + (detailsCurrentPage - 1) * detailsPageSize + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="username"
                label="用户账号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="realname"
                label="用户名称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="status_dictText"
                label="状态"
              ></el-table-column>
              <el-table-column
                label="操作"
                width="150"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-tooltip class="item" content="编辑" placement="top">
                      <div class="pointer mr10" @click="editUser(scope.row)">
                        <span class="hmicon icon-bianji blue"></span>
                      </div>
                    </el-tooltip>
                    <el-tooltip class="item" content="删除" placement="top">
                      <div
                        class="pointer mr10"
                        @click="removes(scope.row, 'details')"
                      >
                        <span class="hmicon icon-shanchu primary"></span>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="roleUserList.total"
              @current-change="detailsPaging"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="detailsCurrentPage"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- 角色录入 -->
      <el-dialog
        :title="mode === 'add' ? '新增' : '编辑'"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        width="800px"
        @close="resetForm('ruleForm')"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="large-label-form"
        >
          <el-form-item label="角色名称：" prop="roleName">
            <el-input
              size="small"
              clearable
              v-model.trim="ruleForm.roleName"
            ></el-input>
          </el-form-item>
          <el-form-item label="角色编码：" prop="roleCode">
            <el-input
              size="small"
              :disabled="mode === 'edit'"
              clearable
              v-model.trim="ruleForm.roleCode"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="description">
            <el-input
              size="small"
              clearable
              type="textarea"
              v-model.trim="ruleForm.description"
            ></el-input>
          </el-form-item>
          <div class="flex flex-center">
            <el-button
              type="primary"
              size="small"
              @click="submitForms('ruleForm')"
              >提交</el-button
            >
            <el-button size="small" @click="resetForm('ruleForm')"
              >返回</el-button
            >
          </div>
        </el-form>
      </el-dialog>
      <!-- 用户添加 -->
      <el-drawer
        :wrapperClosable="false"
        custom-class="hm-drawer"
        :title="detailsMode === 'add' ? '新增' : '编辑'"
        :visible="drawerFormVisible"
        direction="rtl"
        :before-close="handleClose"
      >
        <div class="drawer-content">
          <el-form
            :model="detailsRuleForm"
            :rules="detailsRules"
            ref="detailsRuleForm"
            label-width="100px"
            class="large-label-form"
          >
            <el-form-item label="用户账号：" prop="username">
              <el-input
                size="small"
                clearable
                autocomplete="new-password"
                v-model.trim="detailsRuleForm.username"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="登录密码："
              prop="password"
              v-if="detailsMode === 'add'"
            >
              <el-input
                size="small"
                clearable
                autocomplete="new-password"
                type="password"
                v-model.trim="detailsRuleForm.password"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="确认密码："
              prop="confirmpassword"
              v-if="detailsMode === 'add'"
            >
              <el-input
                size="small"
                clearable
                type="password"
                autocomplete="new-password"
                v-model.trim="detailsRuleForm.confirmpassword"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户名字：" prop="realname">
              <el-input
                size="small"
                clearable
                v-model.trim="detailsRuleForm.realname"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="手机号："
              prop="phone"
              v-if="detailsMode === 'add'"
            >
              <el-input
                size="small"
                clearable
                type="number"
                v-model.trim="detailsRuleForm.phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="头像：">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                noCircle
                :width="100"
                :height="100"
                :params="{ storeId }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
              <div class="headPortrait-wrapper">
                <img
                  @click="toggleShow"
                  :src="detailsRuleForm.avatar"
                  alt="头像"
                />
              </div>
            </el-form-item>
            <el-form-item label="生日：" prop="birthday">
              <el-date-picker
                v-model="detailsRuleForm.birthday"
                type="date"
                size="small"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="性别：" prop="sex">
              <el-select size="small" v-model="detailsRuleForm.sex">
                <el-option :value="1" label="男"></el-option>
                <el-option :value="2" label="女"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
              <el-input
                size="small"
                clearable
                v-model.trim="detailsRuleForm.email"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="drawer-footer flex flex-center item-center">
          <el-button
            type="primary"
            size="small"
            @click="submitForms('detailsRuleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="resetForm('detailsRuleForm')"
            >返回</el-button
          >
        </div>
      </el-drawer>

      <el-dialog
        title="添加已有用户"
        :close-on-click-modal="false"
        :visible.sync="exsistUserDilogVisible"
        width="800px"
        @close="exsistUserDilogVisible = false"
      >
        <div class="table-panel">
          <el-input
            clearable
            v-model.trim="user.username"
            placeholder="请输入姓名"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="searchUser"
            >查询</el-button
          >
        </div>
        <el-table
          stripe
          :data="storeUserList.records"
          @selection-change="handleSelectionChange"
          id="table"
          size="small"
          border
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            :index="
              index =>
                index + (existUserCurrentPage - 1) * existUserPageSize + 1
            "
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="username"
            label="用户账号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            label="用户名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="status_dictText"
            label="状态"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="storeUserList.total"
            @current-change="existUserPaging"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="existUserCurrentPage"
          ></el-pagination>
        </div>
        <div class="flex flex-center p10">
          <el-button type="primary" size="small" @click="saveUsersRole"
            >保存</el-button
          >
          <el-button size="small" @click="calcleSetUsersRole">返回</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="table" v-if="searchCondition.status === 'shenPi'">
      <div class="table-panel flex flex-between">
        <el-button type="primary" size="small" @click="auditDialogVisible = true"
        >添加审批规则</el-button
        >
      </div>
      <el-table
          :data="supplierAuditList"
          stripe
          border
          lazy
          style="width: 100%"
          size="small"
          v-if="resetForm2"
      >
        <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
            prop="codeName"
            label="审批名称"
            header-align="center"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="paramRemark"
            label="审批说明"
            header-align="center"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="phone"
            label="状态"
            header-align="center"
            align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.delFlag == "0" ? "启用" : "停用" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <button
                  class="pointer mr10 no-bg"
                  @click="auditEdit(scope.row)"
              >
                编辑
              </button>
              <button
                  class="pointer mr10 no-bg"
                  @click="auditEditDelFlag(scope.row)"
              >
                {{ scope.row.delFlag == "1" ? "启用" : "停用" }}
              </button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="supplierAuditTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            :page-sizes="[10, 50, 100, 200]"
            layout="total,  prev, pager, next, jumper, sizes"
            :current-page="currentPage"
        ></el-pagination>
      </div>
      <el-dialog
          :close-on-click-modal="false"
          :title="title"
          :visible.sync="dialogVisible"
          @close="resetForm('ruleForm')"
      >
        <el-form
            ref="ruleForm"
            :model="ruleForm"
            :rules="rules"
            label-width="100px"
        >
          <el-form-item label="用户账号" prop="username">
            <el-input
                clearable
                :disabled="title === '编辑用户'"
                v-model.trim="ruleForm.username"
                maxlength="20"
                size="small"
                placeholder="请输入用户账号（20文本内）"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户密码" prop="password">
            <el-input
                clearable
                autocomplete="new-password"
                v-model.trim="ruleForm.password"
                maxlength="20"
                type="password"
                size="small"
                placeholder="请输入用户密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmpassword">
            <el-input
                clearable
                type="password"
                autocomplete="new-password"
                v-model.trim="ruleForm.confirmpassword"
                maxlength="20"
                size="small"
                placeholder="请确认输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名字" prop="realname">
            <el-input
                clearable
                v-model.trim="ruleForm.realname"
                maxlength="20"
                size="small"
                placeholder="请输入用户名字"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属机构" prop="orgCodes">
            <el-cascader
                ref="cascader"
                clearable
                v-model="ruleForm.orgCodes"
                :props="propsprops"
                :show-all-levels="false"
                size="small"
            ></el-cascader>
          </el-form-item>

          <el-form-item label="角色分配" prop="ruleLists">
            <el-select
                v-model="ruleForm.ruleLists"
                value-key="id"
                multiple
                placeholder="请选择"
            >
              <el-option
                  v-for="(item, i) in roleLists"
                  :key="i"
                  :label="item.roleName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="工号" prop="workNum">
            <el-input
                :disabled="disabled"
                maxlength="8"
                clearable
                @input="filterGt0OrFixed2('workNum')"
                v-model.trim="ruleForm.workNum"
                size="small"
                placeholder="请输入工号"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input
                clearable
                v-model.trim="ruleForm.phone"
                size="small"
                type="number"
                placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="在职状态" prop="workingState">
            <el-select
                v-model="ruleForm.workingState"
                placeholder="请选择在职状态"
            >
              <el-option label="在职" value="yes"> </el-option>
              <el-option label="离职" value="no"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否主管" prop="isManager">
            <el-select
                v-model="ruleForm.isManager"
                placeholder="请选择是否主管"
            >
              <el-option label="是" value="yes"> </el-option>
              <el-option label="否" value="no"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="管理品牌" prop="brandRelList">
            <el-select
                clearable
                size="small"
                class="mr10"
                v-model="ruleForm.brandRelList"
                filterable
                multiple
                placeholder="商品品牌,不选则表示全部"
            >
              <!-- <el-option label="全部" value="all"></el-option> -->
              <el-option
                  :label="v.brandName"
                  :value="v.hemiaoBrandId"
                  v-for="(v, i) in allHemiaoBrandBoxList"
                  :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select v-model="ruleForm.sex" placeholder="请选择性别">
              <el-option label="男" value="1"> </el-option>
              <el-option label="女" value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入职时间" prop="regDay">
            <el-date-picker
                v-model="ruleForm.regDay"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="请选择时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="生日" prop="birthday">
            <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="ruleForm.birthday"
                type="date"
                placeholder="请选择时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input
                clearable
                v-model.trim="ruleForm.address"
                maxlength="99"
                size="small"
                placeholder="请输入地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="context">
            <el-input
                clearable
                v-model.trim="ruleForm.context"
                maxlength="99"
                size="small"
                placeholder="请输入备注文本"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="btn-wrapper flex flex-center">
          <el-button size="small" type="primary" @click="saves"
          >确 定</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')"
          >取 消</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
          :close-on-click-modal="false"
          title="添加审批流程"
          :visible.sync="auditDialogVisible"
          @close="resetAuditForm"
      >
        <el-form
            ref="auditForm"
            :model="auditForm"
            :rules="rules"
            label-width="140px"
        >
          <el-form-item label="审批名称" prop="auditName">
            <el-select v-model="auditForm.paramCode" size="small" clearable placeholder="请选择">
              <el-option
                  v-for="item in auditParamList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审批说明" prop="auditRemark">
            <el-input
                clearable
                v-model.trim="auditForm.paramRemark"
                maxlength="20"
                size="small"
                placeholder="请输入审批说明"
            ></el-input>
          </el-form-item>
          <el-form-item label="审批结果查看权限" prop="auditResultCat">
            <el-radio-group v-model="auditForm.supplierAuditValueModel.auditResultCat" size="small" class="flex flex-column">
              <el-radio :label="'yes'">允许上1级查看下级的审批记录</el-radio>
              <el-radio :label="'no'" class="mt20">不允许上1级查看下级的审批记录</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审批人" prop="auditBy" >
            <el-radio-group v-model="auditForm.supplierAuditValueModel.auditBy" @change="auditTypeChange" size="small" class="flex flex-column">
              <el-radio :label="'currentBusiness'">管理区域的业务员</el-radio>
              <el-radio :label="'superiorBusiness'" class="mt20">管辖区域的业务员的上1级主管</el-radio>
              <el-radio :label="'upgradeBusiness'" class="mt20">从业务员开始逐级审核，最多审核<el-input-number :min="1" :max="3" :precision="0" v-model="auditForm.supplierAuditValueModel.upgradeLimit" :controls="false"></el-input-number>人</el-radio>
              <el-radio :label="'noTarget'" class="mt20">不设置</el-radio>
<!--              <el-radio :label="'businessManager'" class="mt20">指定业务员</el-radio>-->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="快捷驳回理由" prop="optionValues">
            <el-input
                style="width: 360px"
                type="textarea"
                v-model="auditForm.optionValues"
                placeholder="多个理由用|隔开"
            ></el-input>
          </el-form-item>
          <el-button size="small" type="primary" @click="queryBusinessManager('add')">选择业务员</el-button>
          <div style="padding-top: 10px;" v-if="businessManager.length > 0 ">
            <el-table
                stripe
                border
                ref="table"
                :data="businessManager"
                style="width: 100%"
                id="table"
                size="small"
            >
              <el-table-column
                  type="index"
                  label="序号"
                  header-align="center"
                  align="center"
              ></el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="realname"
                  label="用户账号"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="username"
                  label="用户名称"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="phone"
                  label="手机号"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="departName"
                  label="所属机构"
              >
              </el-table-column>
              <el-table-column label="操作" header-align="center" align="center">
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button
                        size="small"
                        class="blue"
                        type="text"
                        @click="removeBusinessManager(scope.$index)"
                    >删除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
        <div class="ruleSetArea">
          <div class="ruleSetArea_title"><label>转交规则设置</label></div>
            <el-form ref="form" :model="ruleSetForm" label-width="140px">
              <el-form-item label="申报单自动转交">
                <el-switch v-model="ruleSetForm.autoTransferAudit" active-text="开启"
  inactive-text="关闭" active-color="#13ce66"></el-switch>
              </el-form-item>
              <el-form-item label="转交方案选择" v-if="ruleSetForm.autoTransferAudit">
                  <el-checkbox-group v-model="ruleSetForm.schemeRules.checkedTypeArr" @change="ruleSelecting">
                    <el-checkbox label="1">
                      当金额大于等于<el-input type="number" v-model="ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalAmountThreshold"></el-input>元时,自动转给供应商审核
                    </el-checkbox>
                    <el-checkbox label="2">
                      当数量大于等于<el-input type="number" v-model="ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalNumThreshold"></el-input>件时,自动转给供应商审核
                    </el-checkbox>
                  </el-checkbox-group>
              </el-form-item>
            </el-form>
        </div>
        <div class="btn-wrapper flex flex-center" style="padding-top: 10px;">
          <el-button size="small" type="primary" @click="addAuditConfig"
          >确 定</el-button
          >
          <el-button size="small" @click="resetAuditForm"
          >取 消</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
          :close-on-click-modal="false"
          :title="auditEditTitle"
          :visible.sync="auditEditDialogVisible"
          @close="resetAuditEditForm"
      >
        <el-form
            ref="auditEditForm"
            :model="auditRow"
            :rules="rules"
            label-width="140px"
        >
          <el-form-item label="审批结果查看权限" prop="auditResultCat">
            <el-radio-group v-model="auditRow.supplierAuditValueModel.auditResultCat" size="small" class="flex flex-column">
              <el-radio :label="'yes'">允许上1级查看下级的审批记录</el-radio>
              <el-radio :label="'no'" class="mt20">不允许上1级查看下级的审批记录</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审批人" prop="auditBy" >
            <el-radio-group v-model="auditRow.supplierAuditValueModel.auditBy" size="small" class="flex flex-column"  @change="auditTypeChange">
              <el-radio :label="'currentBusiness'">管理区域的业务员</el-radio>
              <el-radio :label="'superiorBusiness'" class="mt20">管辖区域的业务员的上1级主管</el-radio>
<!--              <el-radio :label="'businessManager'" class="mt20">指定业务员</el-radio>-->
              <el-radio :label="'upgradeBusiness'" class="mt20">从业务员开始逐级审核，最多审核<el-input-number :min="1" :max="3" :precision="0" v-model="auditRow.supplierAuditValueModel.upgradeLimit" :controls="false"></el-input-number>人</el-radio>
              <el-radio :label="'noTarget'" class="mt20">不设置</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="快捷驳回理由" prop="optionValues">
            <el-input
                style="width: 360px"
                type="textarea"
                v-model="auditRow.optionValues"
                placeholder="多个理由用|隔开"
            ></el-input>
          </el-form-item>
        </el-form>

<!--        <div v-if="auditRow.supplierAuditValueModel.auditBy==='businessManager' " class="table-panel flex flex-between">-->
          <el-button size="small" type="primary" @click="queryBusinessManager('edit')">选择业务员</el-button>
<!--        </div>-->
        <div v-if="auditRow.empList">
          <el-table
              stripe
              border
              ref="table"
              :data="auditRow.empList"
              style="width: 100%"
              id="table"
              size="small"
          >
            <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="realname"
                label="用户账号"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="username"
                label="用户名称"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="phone"
                label="手机号"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="departName"
                label="所属机构"
            >
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button
                      size="small"
                      class="blue"
                      type="text"
                      @click="deleteBusinessManager(scope.$index)"
                  >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="ruleSetArea">
          <div class="ruleSetArea_title"><label>转交规则设置</label></div>
            <el-form ref="form" :model="ruleSetForm" label-width="140px">
              <el-form-item label="申报单自动转交">
                <el-switch v-model="ruleSetForm.autoTransferAudit" active-text="开启"
  inactive-text="关闭" active-color="#13ce66"></el-switch>
              </el-form-item>
              <el-form-item label="转交方案选择" v-if="ruleSetForm.autoTransferAudit">
                  <el-checkbox-group v-model="ruleSetForm.schemeRules.checkedTypeArr" @change="ruleSelecting">
                    <el-checkbox label="1">
                      当金额大于等于<el-input type="number" v-model="ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalAmountThreshold"></el-input>元时,自动转给供应商审核
                    </el-checkbox>
                    <el-checkbox label="2">
                      当数量大于等于<el-input type="number" v-model="ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalNumThreshold"></el-input>件时,自动转给供应商审核
                    </el-checkbox>
                  </el-checkbox-group>
              </el-form-item>
            </el-form>
        </div>
        <div class="table-panel btn-wrapper flex flex-center" style="padding-top: 10px;">
          <el-button size="small" type="primary" @click="submitEditConfig"
          >确 定</el-button
          >
          <el-button size="small" @click="resetAuditEditForm"
          >取 消</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
          :close-on-click-modal="false"
          title="选择业务员"
          :visible.sync="businessManagerDialog"
      >
        <el-input
            clearable
            style="width:200px"
            v-model.trim="keyWords"
            placeholder="请输入账户/用户/手机号/工号"
            size="small"
            class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="queryBusinessManager()">查询</el-button>
        <div class="table-panel flex flex-between" style="padding-top: 10px;">
          <el-table
              stripe
              border
              ref="table"
              :data="empList"
              style="width: 100%"
              id="table"
              size="small"
              @selection-change="selectBusinessManagerRow"
          >
            <el-table-column
                type="selection"
            ></el-table-column>
            <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="realname"
                label="用户账号"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="username"
                label="用户名称"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="phone"
                label="手机号"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="departName"
                label="所属机构"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="businessManagerTotal"
              @current-change="businessManagerPain"
              @size-change="businessManagerChange"
              :page-sizes="[10, 50, 100, 200]"
              layout="total,  prev, pager, next, jumper, sizes"
              :current-page="currentPage"
          ></el-pagination>
        </div>
        <div class="btn-wrapper flex flex-center" style="padding-top: 10px;">
          <el-button size="small" type="primary" @click="selectBusinessManager"
          >确 定</el-button
          >
          <el-button size="small" @click="closeBusinessManager"
          >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>

  </hm-content>
</template>

<script>
import { outPutMixin } from "@/mixins/outputMixin";
import { mapGetters } from "vuex";
import moment from "moment";
import myUpload from "vue-image-crop-upload";
import { request } from "@/utils/request";
import XLSX from "xlsx"
import {arrayUnique2} from "@/utils/utils";
import {exportJsonToExcel} from "@/utils/output/Export2Excel";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  mixins: [outPutMixin],
  components: { myUpload },
  data() {
    const patternLocation = function(rule, val, callback) {
      let haveEmptyCondition = false;

      const reg = /^[0-9a-zA-Z]+$/;
      if (!reg.test(val)) {
        haveEmptyCondition = true;
      }
      if (haveEmptyCondition) {
        return callback(
          new Error("编号为唯一值，仅支持英文和数字，不支持其他符号")
        );
      }
      callback();
    }.bind(this);
    const validator = function(rule, val, callback) {
      if (val === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    }.bind(this);

    const validatorFunc = function(rule, val, callback) {
      if (this.ruleForm.password === this.ruleForm.confirmpassword) {
        callback();
      } else {
        return callback(new Error("两次输入密码不一致"));
      }
    }.bind(this);

    const validatorOrgCodesFunc = function(rule, val, callback) {
      if (val.length <= 0) {
        return callback(new Error("请选择所属机构"));
      }

      callback();
    }.bind(this);
    const validatorFuncs = function(rule, val, callback) {
      if (
        this.detailsRuleForm.password === this.detailsRuleForm.confirmpassword
      ) {
        callback();
      } else {
        return callback(new Error("两次输入密码不一致"));
      }
    }.bind(this);
    const checkPhone = function(rule, val, callback) {
      if (/^1[0-9]{10}$/.test(val)) {
        request({
          url: `/sys/duplicate/check`,
          method: "get",
          params: {
            tableName: "store_user",
            fieldName: "phone",
            fieldVal: val,
            dataId: this.userId
          }
        })
          .then(() => {
            callback();
          })
          .catch(() => {
            return callback(new Error("手机号已存在"));
          });
      }
    }.bind(this);
    const checkUsername = (rule, val, callback) => {
      if (val) {
        request({
          url: `/sys/duplicate/check`,
          method: "get",
          params: {
            tableName: "store_user",
            fieldName: "username",
            fieldVal: val
          }
        })
          .then(() => {
            callback();
          })
          .catch(() => {
            return callback(new Error("用户名已存在"));
          });
      }
    };
    return {
      empList: [],
      auditType: "",
      businessManagerDialog: false,
      businessSelectType: "",
      businessManager: [],
      businessManagerTotal: 0,
      allHemiaoBrandBoxList: [],
      storeName: "",
      searchCondition: {
        status: "zuZhi"
      },
      parentName: "",
      mode: "add",
      id: "",
      show: true,
      disabled: false,
      options: [
        {
          value: "1",
          label: "无上级机构"
        }
      ],
      title: "",
      ruleForm: {
        orgCode: "",
        brandRelList: [],
        departName: "",
        description: "",
        mobile: "",
        parentId: "",
        roleName: "",
        roleCode: "",
        username: "",
        realname: "",
        password: "",
        confirmpassword: "",
        phone: "",
        context: "",
        workNum: "",
        birthday: "",
        sex: "",
        regDay: "",
        workingState: "",
        isManager: "",
        ruleLists: [],
        orgCodes: [],
        address: ""
      },
      rules: {
        orgCode: [
          {
            required: true,
            trrger: "blur",
            message: "请输入机构编码"
          },
          { max: 20, message: "长度在20个字符内", trigger: "blur" },
          {
            required: true,
            validator: patternLocation,
            trigger: "blur"
          }
        ],
        parentId: {
          required: true,
          message: "请选择上级机构"
        },
        departName: [
          {
            required: true,
            trrger: "blur",
            message: "请输入机构全名"
          },
          { max: 50, message: "长度在50个字符内", trigger: "blur" }
        ],
        mobile: [
          {
            required: true,
            message: "请输入电话",
            trigger: "blur"
          },
          { min: 11, max: 12, message: "请输入正确的电话", trigger: "blur" }
        ],
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
          { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" }
        ],
        roleCode: {
          required: true,
          message: "请输入角色编码",
          trigger: "blur"
        },
        description: {
          max: 126,
          message: "长度不超过 126 个字符",
          trigger: "blur"
        },
        username: [
          {
            max: 20,
            message: "长度在20个字符内",
            trigger: "blur"
          },
          {
            required: true,
            trrger: "blur",
            message: "请输入用户账户"
          }
        ],
        password: [
          {
            required: true,
            validator: validator,
            trigger: "blur"
          },
          { min: 8, max: 48, message: "长度在8到32个字符", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          },
          {
            required: true,
            trrger: "blur",
            message: "请输入用户密码"
          }
        ],
        confirmpassword: [
          {
            required: true,
            validator: validatorFunc,
            trigger: "blur"
          },
          { min: 8, max: 48, message: "长度在8到32个字符", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          },
          {
            required: true,
            trrger: "blur",
            message: "请再次输入用户密码"
          }
        ],
        realname: [
          {
            max: 20,
            message: "长度在20个字符内",
            trigger: "blur"
          },
          {
            required: true,
            trrger: "blur",
            message: "请输入用户名"
          }
        ],
        orgCodes: {
          required: true,
          validator: validatorOrgCodesFunc,
          message: "请选择所属机构"
        },
        ruleLists: {
          required: true,
          message: "请选择角色"
        },
        workNum: {
          required: true,
          trrger: "blur",
          message: "请输入工号"
        },
        phone: [
          {
            required: true,
            trrger: "blur",
            message: "请输入手机号"
          },
          {
            required: true,
            pattern: /^1[0-9]{10}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        workingState: {
          required: true,
          message: "请选择在职状态"
        },
        isManager: {
          required: true,
          message: "请选择是否主管"
        }
      },
      dialogVisible: false,
      keyWords: "",
      pageSize: 10,
      currentPage: 1,
      sort: {},
      props: {
        // label: "slotTitle",
        // children: "children",
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationListTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.treeStruct;
                  v.label = v.departName;
                });
                res.result.records.unshift({
                  leaf: true,
                  value: "1",
                  label: "无上级机构"
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryListOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.treeStruct;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      expandTree: true,
      authorizeDialogVisible: false,
      dialogFormVisible: false,
      createTime_begin: "",
      createTime_end: "",
      createTime: [],
      lastpermissionIds: "",
      roleName: "",
      isChecked: false,
      errEmployeeVisible: false,
      errEmployeeVisible1:false,
      errEmployeeList: [],
      errEmployeeList1: [],
      succEmployeeList: [],
      currentRow: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      employeeId: "",
      orgCode: "",
      workingState: "yes",
      syncFlag: "",
      roleLists: [],
      propsprops: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationListTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryListOrganizationListByParentNew", {
                parentId: data.treeStruct,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      currentRoleId: "",
      username: "",
      user: {
        username: ""
      },
      userIdList: [],
      // show: false,
      storeId: "",
      drawerFormVisible: false,
      // roleName: "",
      // createTime: [],
      exsistUserDilogVisible: false,
      activityChildCategoryList: [],
      // currentPage: 1,
      // pageSize: 10,
      detailsCurrentPage: 1,
      detailsPageSize: 10,
      existUserCurrentPage: 1,
      existUserPageSize: 10,
      startDate: "",
      endDate: "",
      timeStatus: "all",
      date: [],
      // mode: "add",
      isShowDetail: "",
      isOutputing: false,
      // dialogFormVisible: false,
      detailsMode: "add",
      // ruleForm: {
      //   roleName: "",
      //   roleCode: "",
      //   description: ""
      // },
      // currentRow: {},
      currentDetailsRow: {},
      // rules: {
      //   roleName: [
      //     { required: true, message: "请输入角色名称", trigger: "blur" },
      //     { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" }
      //   ],
      //   roleCode: {
      //     required: true,
      //     message: "请输入角色编码",
      //     trigger: "blur"
      //   },
      //   description: {
      //     max: 126,
      //     message: "长度不超过 126 个字符",
      //     trigger: "blur"
      //   }
      // },
      defaultAvatar:
        "https://imgcdn.hemiao100.com/hemiaoBase/ce9c2cec-bead-43a0-9de3-2bc3e9e16acb.png",
      detailsRuleForm: {
        username: "",
        password: "",
        confirmpassword: "",
        realname: "",
        birthday: "",
        sex: "",
        email: "",
        phone: "",
        avatar: "https://imgcdn.hemiao100.com/hemiaoBase9de3-2bc3e9e16acb.png"
      },
      propsTree: {
        label: "slotTitle",
        children: "children"
      },
      detailsRules: {
        username: [
          {
            required: true,
            message: "请输入用户账号！",
            trigger: "blur"
          },
          {
            max: 12,
            message: "长度应小于12个字符",
            trigger: "blur"
          },
          {
            validator: checkUsername,
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码!",
            trigger: "blur"
          },
          { min: 8, max: 12, message: "长度在8到12个字符", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          }
        ],
        confirmpassword: [
          {
            required: true,
            validator: validatorFuncs,
            trigger: "blur"
          },
          { min: 8, max: 12, message: "长度在8到12个字符", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          }
        ],
        realname: [
          {
            required: true,
            message: "请输入用户名称！",
            trigger: "blur"
          },
          {
            max: 12,
            message: "长度应小于12个字符",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            pattern: /^1[0-9]{10}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          },
          {
            validator: checkPhone,
            trigger: "blur"
          }
        ],
      },
      supplierAuditList: [],
      supplierAuditTotal: 0,
      auditDialogVisible: false,
      auditForm: {
        paramCode: "",
        paramRemark: "",
        codeName: "",
        supplierAuditValueModel: {
          auditBy: "currentBusiness",
          auditResultCat: "yes",
          upgradeLimit: undefined
        },
        optionValues: "",
      },
      auditParamList: [
        {
          label: "月结单申报审批",
          value: "declareAudit"
        },
        {
          label: "异常单申报审批",
          value: "errorAudit"
        },
        {
          label: "报名活动审批",
          value: "tiktokLikePasAudit"
        }
      ],
      auditRow: {
        supplierAuditValueModel: {
          auditBy: "",
          auditResultCat: "",
          upgradeLimit: undefined
        },
        optionValues: "",
        empList: []
      },
      auditEditDialogVisible: false,
      resetForm2: true,
      auditEditTitle: "",
      rows: [],
      //转交规则设置
      ruleSetForm: {
        autoTransferAudit: false,
        schemeRules: {
          supplierGoodsTotalAmountThreshold:false,
          autoTransferSupplierGoodsTotalAmountThreshold: "",
          supplierGoodsTotalNumThreshold:false,
          autoTransferSupplierGoodsTotalNumThreshold: "",
          checkedTypeArr: [],
        },
      },
    };
  },
  computed: {
    contentHeight() {
      return window.innerHeight - 59 + "px";
    },
    ...mapGetters([
      "organizationList",
      "byIdOrganization",
      "roleList",
      "roleUserList",
      "allRoleUserList",
      "roleTreeList",
      "currentRolePermiision",
      "allEmployeeList",
      "storeUserList"
    ])
  },
  watch: {
    createTime(v) {
      if (v) {
        this.createTime_begin = v ? v[0] : "";
        this.createTime_end = v ? v[1] : "";
      }
    },
    currentRolePermiision(v) {
      this.$refs.tree.setCheckedKeys(v);
      this.lastpermissionIds = v.join(",");
    },
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    },
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    }
  },
  created() {},
  mounted() {
    this.storeName = localStorage.getItem("storeName");
    this.queryList(this.searchCondition.status);
    this.$store.dispatch("queryAllHemiaoBrandComboBox").then(res => {
      res.result.forEach(v => {
        v.disabled = false;
      });
      this.allHemiaoBrandBoxList = res.result;
    });
  },
  methods: {
    auditTypeChange(val) {
      this.auditType = val;
      this.auditRow.supplierAuditValueModel.upgradeLimit = undefined;
      this.auditForm.supplierAuditValueModel.upgradeLimit = undefined;
    },
    queryBusinessManager(type) {
      if(type){
        this.businessSelectType = type;
      }
      this.rows = [];
      this.businessManagerDialog = true;
      this.$store.dispatch("queryEmployeeList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        loginType: "supplier",
        storeCode: this.$route.query.storeCode,
        queryKey: this.keyWords,
        workingState: "yes"
      }).then(res=>{
        if (res.code === '0') {
          this.empList = res.result.records;
          this.businessManagerTotal = res.result.total;
        }
      });
      console.log("this.empList:::", this.empList);
      console.log("this.businessManagerTotal:::", this.businessManagerTotal);
    },
    businessManagerPain(page) {
      this.currentPage = page;
      this.queryBusinessManager();
    },
    businessManagerChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryBusinessManager();
    },
    selectBusinessManagerRow(rows) {
      console.log(this.businessSelectType);
      console.log("rows::::", rows);
      this.rows = rows;
    },
    selectBusinessManager() {
      if (this.rows.length > 0) {
        if (this.businessSelectType === 'add') {
          if (this.businessManager.length <= 0) {
            this.businessManager = this.rows;
          } else {
            this.rows.forEach((data)=>{
              let flag = false;
              this.businessManager.forEach(ma=>{
                if (ma.id === data.id) {
                  flag = true;
                }
              })
              if (!flag) {
                this.businessManager.push(data)
              }
            });
          }
        } else if (this.businessSelectType === 'edit') {
          if (this.auditRow.empList <= 0) {
            this.auditRow.empList = this.rows;
          } else {
            this.rows.forEach((data)=>{
              let flag = false;
              this.auditRow.empList.forEach(ma=>{
                if (ma.id === data.id) {
                  flag = true;
                }
              })
              if (!flag) {
                this.auditRow.empList.push(data)
              }
            });
          }
        }
      }
      console.log("open:::", this.businessManager);
      this.businessManagerDialog = false;
    },
    closeBusinessManager() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.businessManagerDialog = false;
    },
    removeBusinessManager(i) {
      this.businessManager.splice(i, 1);
    },
    deleteBusinessManager(i) {
      console.log("I：：：：：", this.auditRow.empList[i])
      console.log(this.auditRow.id)
      console.log(this.$route.query.storeCode)
      let row = this.auditRow.empList[i];
      this.auditRow.empList.splice(i, 1);
      this.$store.dispatch("removeAuditManager", {
            storeUserIds: [row.id],
            id: this.auditRow.id,
            storeCode: this.$route.query.storeCode
          })
    },
    auditEditDelFlag(row) {
      let state = row.delFlag == "0" ? "1" : "0";
      let str = row.delFlag == "0" ? "停用" : "启用";
      this.$confirm("是否" + str + "该审批流程", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.$store
                .dispatch("editDelFlagSupplierAudit", {
                  id: row.id,
                  delFlag: state
                })
                .then(res => {
                  if (res.code === "0") {
                    this.$message({
                      message: "操作成功!",
                      type: "success"
                    });
                    this.queryList("shenPi");
                  }
                });
          })
          .catch(err => {
            throw new Error(err);
          });
    },
    resetAuditEditForm() {
      this.auditRow = {
        supplierAuditValueModel: {
          auditBy: "",
          auditResultCat: "",
          upgradeLimit: undefined
        }
      };
      this.ruleSetForm = {
        autoTransferAudit: false,
        schemeRules: {
          supplierGoodsTotalAmountThreshold:false,
          autoTransferSupplierGoodsTotalAmountThreshold: "",
          supplierGoodsTotalNumThreshold:false,
          autoTransferSupplierGoodsTotalNumThreshold: "",
          checkedTypeArr: [],
        },
      }
      this.auditEditDialogVisible = false;
    },
    async submitEditConfig() {
      let params = {
        id: this.auditRow.id,
        supplierAuditValueModel: {
          auditBy: this.auditRow.supplierAuditValueModel.auditBy,
          auditResultCat: this.auditRow.supplierAuditValueModel.auditResultCat,
          upgradeLimit: this.auditRow.supplierAuditValueModel.upgradeLimit
        }
      }
      if (params.supplierAuditValueModel.auditBy === "upgradeBusiness" && !params.supplierAuditValueModel.upgradeLimit) {
        return this.$message({
          message: "请输入最多审核人数！",
          type: "warning"
        });
      }
       if (params.supplierAuditValueModel.auditBy === "noTarget" && (!this.auditRow.empList || this.auditRow.empList.length == 0)) {
        return this.$message({
          message: "请选择业务员！",
          type: "warning"
        });
      }
      if (this.auditRow.empList && this.auditRow.empList.length > 0) {
        let userIds = [];
        this.auditRow.empList.forEach(mp=>{
          userIds.push(mp.id);
        })
        params.storeUserIds = userIds;
        params.storeCode = this.$route.query.storeCode;
      }
      params.optionValues = this.auditRow.optionValues;
      var reg = /^[0-9]*[1-9][0-9]*$/
      var reg1 = /^0\.\d*[1-9]$|^[1-9]\d*(\.\d+)?$/
      var reg2=/^\d+(\.\d{1,2})?$/;
      if(this.ruleSetForm.autoTransferAudit){
        if (this.ruleSetForm.schemeRules.checkedTypeArr.length<=0) {
          return this.$message({
            message: "请最少选择一个方案",
            type: "warning"
          });
          }else if(this.ruleSetForm.schemeRules.checkedTypeArr.includes('1')&&(!reg1.test(this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalAmountThreshold))){
            console.log(this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalAmountThreshold)
            return this.$message({
            message: "请输入正确金额",
            type: "warning"
            });
          }else if(this.ruleSetForm.schemeRules.checkedTypeArr.includes('1')&&(!reg2.test(this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalAmountThreshold))){
              return this.$message({
              message: "金额不能超过小数点后2位",
              type: "warning"
              });
          } else if(this.ruleSetForm.schemeRules.checkedTypeArr.includes('2')&&(!reg.test(this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalNumThreshold))){
            return this.$message({
              message: "请输入正确的数量",
              type: "warning"
            });
          }
          params.supplierAuditValueModel.autoTransferAudit = this.ruleSetForm.autoTransferAudit
          if(this.ruleSetForm.schemeRules.checkedTypeArr.includes('1')){
            params.supplierAuditValueModel.autoTransferSupplierGoodsTotalAmountThreshold = this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalAmountThreshold*1
            params.supplierAuditValueModel.supplierGoodsTotalAmountThreshold = true
          }else{
            params.supplierAuditValueModel.supplierGoodsTotalAmountThreshold = false
          }
          if(this.ruleSetForm.schemeRules.checkedTypeArr.includes('2')){
            params.supplierAuditValueModel.autoTransferSupplierGoodsTotalNumThreshold = this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalNumThreshold*1
            params.supplierAuditValueModel.supplierGoodsTotalNumThreshold = true
          }else{
            params.supplierAuditValueModel.supplierGoodsTotalNumThreshold = false
          }
      }
      await this.$store.dispatch("editSupplierAudit", params);
      this.$message({
        message: "操作成功！",
        type: "success"
      });
      this.auditEditDialogVisible = false;
      this.queryList("shenPi");
    },
    resetAuditForm() {
      this.auditForm = {
        paramCode: "",
            paramRemark: "",
            codeName: "",
            supplierAuditValueModel: {
          auditBy: "currentBusiness",
              auditResultCat: "yes",
              upgradeLimit: undefined
        }
      };
       this.ruleSetForm = {
        autoTransferAudit: false,
        schemeRules: {
          supplierGoodsTotalAmountThreshold:false,
          autoTransferSupplierGoodsTotalAmountThreshold: "",
          supplierGoodsTotalNumThreshold:false,
          autoTransferSupplierGoodsTotalNumThreshold: "",
          checkedTypeArr: [],
        },
      }
      this.auditDialogVisible = false;
      this.businessManager = [];
    },
    async querySupplierAuditList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeCode: this.$route.query.storeCode,
        configType: "supplier",
      }
      const { result } = await this.$store.dispatch("querySupplierAuditList", params);
      let arrs = [];
      result.records.forEach(item =>{
        if(item.paramValue !== "can_not_receipt"){
          arrs.push(item);
        }
      });
      this.supplierAuditList = arrs;
      this.supplierAuditTotal = result.total;
    },
    auditEdit(row) {
      this.auditRow = JSON.parse(JSON.stringify(row));
      this.auditEditTitle = "编辑审批流程(" + this.auditRow.codeName + ")";
      if (row.empList) {
        this.auditRow.empList = row.empList;
      }
      if (this.auditRow.paramValue && this.auditRow.paramValue != "null") {
        this.auditRow.supplierAuditValueModel = JSON.parse(this.auditRow.paramValue);
      } else {
        this.auditRow.supplierAuditValueModel = {
          auditBy: "",
          auditResultCat: "",
          upgradeLimit: undefined
        }
      }
      this.auditEditDialogVisible = true;
      this.ruleSetForm.schemeRules.checkedTypeArr=[]
      this.ruleSetForm.autoTransferAudit = (JSON.parse(row.paramValue)).autoTransferAudit
      if((JSON.parse(row.paramValue)).autoTransferSupplierGoodsTotalAmountThreshold>0){
        this.ruleSetForm.schemeRules.checkedTypeArr.push('1')
      }
      if((JSON.parse(row.paramValue)).autoTransferSupplierGoodsTotalNumThreshold>0){
        this.ruleSetForm.schemeRules.checkedTypeArr.push('2')
      }
      this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalAmountThreshold = (JSON.parse(row.paramValue)).autoTransferSupplierGoodsTotalAmountThreshold==0?'':(JSON.parse(row.paramValue)).autoTransferSupplierGoodsTotalAmountThreshold
      this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalNumThreshold = (JSON.parse(row.paramValue)).autoTransferSupplierGoodsTotalNumThreshold==0?'':(JSON.parse(row.paramValue)).autoTransferSupplierGoodsTotalNumThreshold
    },
    /**
     * @desc 添加审批规则，新增审批名称选择时后端也需要添加枚举做匹配，不然返回的表格数据没有审批名称
    */
    async addAuditConfig() {
      let params = JSON.parse(JSON.stringify(this.auditForm));
      params.storeCode = this.$route.query.storeCode;
    
      if (params.supplierAuditValueModel.auditBy === "noTarget" && this.businessManager.length == 0) {
        return this.$message({
          message: "请选择业务员！",
          type: "warning"
        });
      }
      if (this.businessManager.length > 0) {
        let userIds = [];
        this.businessManager.forEach(mp=>{
          userIds.push(mp.id);
        })
        params.storeUserIds = userIds;
      }
      if (params.supplierAuditValueModel.auditBy === "upgradeBusiness" && !params.supplierAuditValueModel.upgradeLimit) {
        return this.$message({
          message: "请输入最多审核人数！",
          type: "warning"
        });
      }
      
      var reg = /^[0-9]*[1-9][0-9]*$/
      var reg1 = /^0\.\d*[1-9]$|^[1-9]\d*(\.\d+)?$/
      var reg2=/^\d+(\.\d{1,2})?$/;
       if(this.ruleSetForm.autoTransferAudit){
        if (this.ruleSetForm.schemeRules.checkedTypeArr.length<=0) {
          return this.$message({
            message: "请最少选择一个方案",
            type: "warning"
          });
          }else if(this.ruleSetForm.schemeRules.checkedTypeArr.includes('1')&&(!reg1.test(this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalAmountThreshold))){
            console.log(this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalAmountThreshold)
            return this.$message({
            message: "请输入正确金额",
            type: "warning"
            });
          }else if(this.ruleSetForm.schemeRules.checkedTypeArr.includes('1')&&(!reg2.test(this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalAmountThreshold))){
              return this.$message({
              message: "金额不能超过小数点后2位",
              type: "warning"
              });
            }  else if(this.ruleSetForm.schemeRules.checkedTypeArr.includes('2')&&(!reg.test(this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalNumThreshold))){
            return this.$message({
              message: "请输入正确的数量",
              type: "warning"
            });
          }
          params.supplierAuditValueModel.autoTransferAudit = this.ruleSetForm.autoTransferAudit
          if(this.ruleSetForm.schemeRules.checkedTypeArr.includes('1')){
            params.supplierAuditValueModel.autoTransferSupplierGoodsTotalAmountThreshold = this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalAmountThreshold*1
            params.supplierAuditValueModel.supplierGoodsTotalAmountThreshold = true
          }else{
            params.supplierAuditValueModel.supplierGoodsTotalAmountThreshold = false
          }
          if(this.ruleSetForm.schemeRules.checkedTypeArr.includes('2')){
            params.supplierAuditValueModel.autoTransferSupplierGoodsTotalNumThreshold = this.ruleSetForm.schemeRules.autoTransferSupplierGoodsTotalNumThreshold*1
            params.supplierAuditValueModel.supplierGoodsTotalNumThreshold = true
          }else{
            params.supplierAuditValueModel.supplierGoodsTotalNumThreshold = false
          }
      }

      await this.$store.dispatch("saveSupplierAudit", params);
      this.$message({
        message: "操作成功！",
        type: "success"
      });
      this.auditDialogVisible = false;
      this.queryList("shenPi");
    },
    brandChange(val) {
      // this.ruleForm.brandRelList = ["all"];
      // this.allHemiaoBrandBoxList.forEach(v => {
      //   v.disabled = true;
      // });
    },
    switchTab() {
      this.resetForm2 = false;
      this.$nextTick(()=>{
          this.resetForm2 = true;
      })
      this.currentPage = 1;
      this.checkedRow = [];
      this.queryList(this.searchCondition.status);
    },
    addOrganization() {
      this.mode = "add";
      this.title = "新增机构";
      this.dialogVisible = true;
      this.disabled = false;
      this.ruleForm = {};
      this.id = "";
      this.show = true;
      // setTimeout(() => {
      //   this.resetRuleForm();
      // }, 0);
    },
    async output1() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
      });
      var list = [],tHeader = [],filterVal = [],exportName="";
      if (this.searchCondition.status === 'zuZhi') {
        const result = await this.$store.dispatch("queryListOrganizationListByParent", {
          departName: this.keyWords,
          loginType: "",
          storeCode: this.$route.query.storeCode
        });
        list = result.result;
        tHeader = [
          "机构全名",
          "机构编号",
        ];
        filterVal = [
          "departName",
          "orgCode",
        ];
        exportName = "组织架构";
      } else if(this.searchCondition.status === 'zhiYuan') {
        const result = await this.$store.dispatch("queryEmployee", {
          pageNo: this.currentPage,
          pageSize: this.allEmployeeList.total,
          queryKey: this.keyWords,
          orgCode: this.orgCode,
          workingState: this.workingState,
          syncFlag: this.syncFlag,
          loginType: "supplier",
          storeCode: this.$route.query.storeCode
        });
        list = result.result.records;
        tHeader = [
          "用户账号",
          "用户姓名",
          "所属机构",
          "手机号",
          "工号",
          "机构编号"
        ];
        filterVal = [
          "username",
          "realname",
          "departName",
          "phone",
          "workNum",
          "orgCode"
        ];
        exportName = "职员信息";
      }
      
      const data = this.formatJson(filterVal, list);
      exportJsonToExcel(
          tHeader,
          data,
          exportName + new Date().toLocaleString()
      );
      this.isOutputing = false;
      // this.$store.dispatch("queryListOrganizationListByParent", {
      //   departName: this.keyWords,
      //   loginType: "",
      //   storeCode: this.$route.query.storeCode
      // })
      // .then(res => {
      //   console.log('res--',res);
      //   //const list = res.result;
      //   const data = this.formatJson(filterVal, list);
      //   exportJsonToExcel(
      //       tHeader,
      //       data,
      //       "组织架构" + new Date().toLocaleString()
      //   );
      //   this.isOutputing = false;
      // });
    },
    queryList(val, queryAll) {
      if (val === "zuZhi") {
        this.$store.dispatch("queryOrganizationList", {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          departName: this.keyWords,
          loginType: "supplier",
          storeCode: this.$route.query.storeCode
        });
      } else if (val === "jueSe") {
        const params = {
          pageSize: queryAll ? 99999 : this.pageSize,
          pageNo: this.currentPage,
          createTime_begin: this.createTime_begin,
          createTime_end: this.createTime_end,
          roleName: this.roleName,
          column: "createTime",
          order: "desc",
          loginType: "supplier",
          storeCode: this.$route.query.storeCode
        };
        const actionName = queryAll ? "queryAllRoleList" : "queryRoleList";
        return this.$store.dispatch(actionName, params);
      } else if (val === "zhiYuan") {
        this.$store.dispatch("queryEmployeeList", {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          queryKey: this.keyWords,
          orgCode: this.orgCode,
          workingState: this.workingState,
          syncFlag: this.syncFlag,
          loginType: "supplier",
          storeCode: this.$route.query.storeCode
        });
      } else if (val === "weiHu") {
        const params = {
          pageSize: queryAll ? 99999 : this.pageSize,
          pageNo: this.currentPage,
          roleName: this.roleName,
          column: "createTime",
          order: "desc",
          loginType: "supplier",
          storeCode: this.$route.query.storeCode
        };
        const actionName = queryAll ? "queryAllRoleList" : "queryRoleList";
        return this.$store.dispatch(actionName, params);
      } else if (val == "shenPi") {
        this.querySupplierAuditList();
      }
    },
    search() {
      this.currentPage = 1;
      if (typeof this.orgCode == "object") {
        this.orgCode = this.orgCode[this.orgCode.length - 1];
      }
      this.queryList(this.searchCondition.status);
    },
    paging(page) {
      this.currentPage = page;
      this.queryList(this.searchCondition.status);
    },
    sortChange(sort) {
      this.sort = sort;

      this.queryList(this.searchCondition.status);
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList(this.searchCondition.status);
    },

    load(tree, treeNode, resolve) {
      const { treeStruct } = tree;
      resolve([]);
      this.$store
        .dispatch("queryListOrganizationListByParent", {
          parentId: treeStruct,
          loginType: "supplier",
          storeCode: this.$route.query.storeCode
        })
        .then(res => {
          if (res.code === "0" && res.result.length) {
            res.result.forEach(v => {
              v.hasChildren = Boolean(v.isParent);
            });
            resolve(res.result);
          } else {
            resolve([]);
          }
        });
    },
    edit(row, val) {
      if (val === "zuZhi") {
        this.mode = "edit";
        this.title = "编辑机构";

        this.id = row.id;
        const params = {
          id: this.id,
          loginType: "supplier",
          storeCode: this.$route.query.storeCode
        };
        this.dialogVisible = true;
        // if (row.syncFlag !== "hemiao") {
        //   this.disabled = true;
        // } else {
        //   this.disabled = false;
        // }
        this.disabled = true;
        this.show = false;

        this.$store.dispatch("queryByIdOrganization", params).then(res => {
          const result = res.result || {};

          if (res.code == 0) {
            result.parentId = [result.parentId];
            for (let key in result) {
              if (this.ruleForm.hasOwnProperty(key)) {
                setTimeout(() => {
                  if (this.$refs.cascader) {
                    this.$refs.cascader.presentText = result.parentName;
                    if (result.orgType == 1) {
                      this.$refs.cascader.presentText = "无上级机构";
                    }
                  }
                }, 0);
                // this.ruleForm.parentId = [result.parentId];
                this.ruleForm[key] = result[key];
              }
            }
          }
        });
      } else if (val === "jueSe") {
        this.mode = "edit";
        this.currentRow = row;
        this.dialogFormVisible = true;
        for (let key in row) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = row[key];
          }
        }
      } else if (val === "zhiYuan") {
        if (row.syncFlag === "erp") {
          this.disabled = true;
        }
        this.dialogVisible = true;
        this.title = "编辑用户";
        this.id = row.id;
        this.employeeId = row.employeeId;
        const params = {
          id: row.employeeId,
          loginType: "supplier",
          storeCode: this.$route.query.storeCode
        };
        this.$store.dispatch("queryByIdEmployee", params).then(res => {
          const result = res.result || {};
          if (res.code == 0) {
            result.ruleLists = result.ruleList;
            result.orgCodes = result.orgCode;
            for (let key in result) {
              if (this.ruleForm.hasOwnProperty(key)) {
                this.ruleForm[key] = result[key];
                setTimeout(() => {
                  if (this.$refs.cascader) {
                    this.$refs.cascader.presentText = result.departName;
                  }
                }, 0);
              }
            }
            this.ruleForm.confirmpassword = this.ruleForm.password;
            this.queryRoleList();
            // .then(res => {
            //   this.roleList = res.result.records;
            // });
            let list = [];

            result.ruleLists.map(v => {
              list.push(v.roleId);
            });
            this.ruleForm.ruleLists = list;
          }
        });
      } else if (val === "weiHu") {
        this.mode = "edit";
        this.currentRow = row;
        this.dialogFormVisible = true;
        for (let key in row) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = row[key];
          }
        }
      }
    },
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = this.ruleForm;

          params.id = this.id;

          if (typeof params.parentId == "object") {
            params.parentId = params.parentId[params.parentId.length - 1];
            if (params.parentId == 1) {
              params.parentId = "";
            }
          }
          params.loginType = "supplier";
          params.storeCode = this.$route.query.storeCode;
          this.$store.dispatch("checkOrganization", params).then(res => {
            if (res.code === "0") {
              this.$store
                .dispatch(
                  this.show ? "addOrganization" : "editOrganizationBasic",
                  params
                )
                .then(res => {
                  if (res.code === "0") {
                    this.$message({
                      message: "操作成功",
                      type: "success"
                    });
                    this.dialogVisible = false;
                    this.$store.commit("QUERY_ORGANIZATION_LIST", {
                      result: { record: [] }
                    });
                    this.queryList(this.searchCondition.status);
                  }
                });
            }
          });
        } else {
          return false;
        }
      });
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
      }, 0);
    },
    savePermission() {
      const idList = this.$refs.tree.getCheckedNodes().map(v => v.value);
      this.$store
        .dispatch("saveRolePermission", {
          lastpermissionIds: this.lastpermissionIds,
          permissionIds: idList.join(","),
          roleId: this.currentRow.id,
          loginType: "supplier",
          storeCode: this.$route.query.storeCode
        })
        .then(res => {
          if (res.success) {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.authorizeDialogVisible = false;
          }
        });
    },
    handleAdd() {
      this.dialogFormVisible = true;
      this.mode = "add";
    },
    handleClose() {
      this.authorizeDialogVisible = false;
      this.drawerFormVisible = false;
    },
    openAuthorizeDialog(row) {
      this.currentRow = row;
      this.authorizeDialogVisible = true;
      this.$store.dispatch("queryRoleTreeList", {
        loginType: "supplier",
        storeCode: this.$route.query.storeCode
      });
      this.$store.dispatch("queryCurrentRolePermission", {
        roleId: row.id,
        loginType: "supplier",
        storeCode: this.$route.query.storeCode
      });
    },
    selectItem(e) {
      let expand = false;
      switch (e) {
        case "checkAll":
          this.$refs.tree.setCheckedNodes(this.roleTreeList);
          break;
        case "cancleCheckAll":
          this.$refs.tree.setCheckedNodes([]);
          break;
        case "openAll":
          expand = true;
          break;
        case "cancleOpenAll":
          expand = false;
          break;
        default:
          break;
      }
      for (let i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
        this.$refs.tree.store._getAllNodes()[i].expanded = expand;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let actionName = "";
          let params = this[formName];
          if (formName === "ruleForm") {
            if (this.mode === "add") {
              actionName = "addRole";
            } else {
              actionName = "editRole";
              Object.assign(params, { id: this.currentRow.id });
            }
          }
          params.loginType = "supplier";
          params.storeCode = this.$route.query.storeCode;
          this.$store.dispatch(actionName, params).then(res => {
            if (res.success) {
              this.dialogFormVisible = false;
              this.queryList(this.searchCondition.status);
            }
          });
        }
      });
    },
    remove(row) {
      this.$confirm(
        `删除<span style="color: red">${row.roleName}</span>?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      ).then(() => {
        this.$store
          .dispatch("deleteRole", {
            id: row.id,
            loginType: "supplier",
            storeCode: this.$route.query.storeCode
          })
          .then(res => {
            if (res.success) {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList(this.searchCondition.status);
            }
          });
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      for (let key in this[formName]) {
        this[formName][key] = "";
      }
      this.dialogVisible = false;
      this.dialogFormVisible = false;
      this.drawerFormVisible = false;
      this.detailsRuleForm.avatar = this.defaultAvatar;
    },
    queryRoleList() {
      const params = {
        pageSize: 99999,
        pageNo: 1,
        column: "createTime",
        order: "desc",
        loginType: "supplier",
        storeCode: this.$route.query.storeCode
      };
      return this.$store.dispatch("queryRoleList", params).then(res => {
        this.roleLists = res.result.records;
      });
    },
    addEmployee() {
      this.dialogVisible = true;
      this.disabled = false;
      this.title = "添加职员";
      this.queryRoleList();
      // .then(res => {
      //   this.roleLists = res.result.records;
      // });
    },
    filterGt0OrFixed2(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\w_]/g, ""); //过滤0开头
    },
    saves() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let list = [];

          this.ruleForm.ruleLists.map(v => {
            list.push({ id: v });
          });

          let params = {
            username: this.ruleForm.username,
            workNum: this.ruleForm.workNum,
            loginType: "supplier",
            storeCode: this.$route.query.storeCode
          };

          // this.$store.dispatch("checkEmployee", params).then(res => {
          // if (res.code === "0") {
          // let param = this.ruleForm;

          params.ruleList = list;

          if (typeof this.ruleForm.orgCodes == "object") {
            this.ruleForm.orgCode = this.ruleForm.orgCodes[
              this.ruleForm.orgCodes.length - 1
            ];
          } else {
            this.ruleForm.orgCode = this.ruleForm.orgCodes;
          }

          if (this.title === "编辑用户") {
            params.id = this.id;
            params.employeeId = this.employeeId;
          }
          Object.assign(params, this.ruleForm);
          params.storeCode = this.$route.query.storeCode;
          params.brandRelList =
            params.brandRelList == "" ? [] : params.brandRelList;
          this.$store
            .dispatch(
              this.title === "添加职员" ? "addEmployee" : "editEmployee",
              params
            )
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogVisible = false;
                this.queryList(this.searchCondition.status);
              }
            });
          // }
          // });
        } else {
          return false;
        }
      });
    },
    userEntry() {
      this.currentRoleId = this.currentRow.id;
      this.drawerFormVisible = true;
      this.detailsMode = "add";
    },
    addExsistdUser() {
      this.exsistUserDilogVisible = true;
      this.queryUserList();
    },
    queryUserList() {
      this.$store.dispatch("queryStoreUserList", {
        column: "createTime",
        order: "desc",
        pageNo: this.existUserCurrentPage,
        pageSize: this.existUserPageSize,
        username: this.user.username,
        roleId: this.currentRow.id,
        loginType: "supplier",
        storeCode: this.$route.query.storeCode
      });
    },
    handleSelectionChange(selection) {
      this.userIdList = selection.map(v => v.id);
    },
    saveUsersRole() {
      this.$store
        .dispatch("addExistUser", {
          roleId: this.currentRow.id,
          userIdList: this.userIdList,
          loginType: "supplier",
          storeCode: this.$route.query.storeCode
        })
        .then(res => {
          if (res.success) {
            this.exsistUserDilogVisible = false;
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryDetailsList();
          }
        });
    },
    calcleSetUsersRole() {
      this.exsistUserDilogVisible = false;
    },
    submitForms(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let actionName = "";
          let params = this[formName];
          if (formName === "ruleForm") {
            if (this.mode === "add") {
              actionName = "addRole";
            } else {
              actionName = "editRole";
              Object.assign(params, { id: this.currentRow.id });
            }
          } else if (formName === "detailsRuleForm") {
            Object.assign(params, {
              selectedroles: this.currentRoleId
            });
            if (this.detailsMode === "add") {
              actionName = "addUser";
            } else {
              actionName = "editUser";
            }
          }
          params.loginType = "supplier";
          params.storeCode = this.$route.query.storeCode;
          this.$store.dispatch(actionName, params).then(res => {
            if (res.success) {
              this.dialogFormVisible = false;
              this.drawerFormVisible = false;
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              if (formName === "ruleForm") {
                this.queryList(this.searchCondition.status);
              } else {
                this.queryDetailsList();
              }
            }
          });
        }
      });
    },
    showDetails(row) {
      this.isShowDetail = true;
      this.currentRow = row;
      this.queryDetailsList();
    },
    removes(row, type) {
      const tip = type ? row.realname : row.roleName;
      this.$confirm(`删除<span style="color: red">${tip}</span>?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(() => {
        if (type) {
          this.$store
            .dispatch("deleteUserRole", {
              roleId: this.currentRow.id,
              userId: row.id,
              loginType: "supplier",
              storeCode: this.$route.query.storeCode
            })
            .then(res => {
              if (res.success) {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryDetailsList();
              }
            });
        } else {
          this.$store
            .dispatch("deleteRole", {
              id: row.id,
              loginType: "supplier",
              storeCode: this.$route.query.storeCode
            })
            .then(res => {
              if (res.success) {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryList(this.searchCondition.status);
              }
            });
        }
      });
    },
    editUser(row) {
      this.currentDetailsRow = row;
      this.drawerFormVisible = true;
      this.detailsMode = "edit";
      for (let key in row) {
        if (this.detailsRuleForm.hasOwnProperty(key)) {
          this.detailsRuleForm[key] = row[key];
        }
      }
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id,
          loginType: "supplier",
          storeCode: this.$route.query.storeCode
        })
        .then(() => {
          this.queryList(this.searchCondition.status);
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    detailsPaging(page) {
      this.detailsCurrentPage = page;
      this.queryDetailsList();
    },
    existUserPaging(page) {
      this.existUserCurrentPage = page;
      this.queryUserList();
    },
    queryDetailsList() {
      this.$store.dispatch("queryRoleUserList", {
        roleId: this.currentRow.id,
        pageNo: this.detailsCurrentPage,
        pageSize: this.detailsPageSize,
        username: this.username,
        column: "createTime",
        order: "desc",
        loginType: "supplier",
        storeCode: this.$route.query.storeCode
      });
    },
    searchDetails() {
      this.detailsCurrentPage = 1;
      this.queryDetailsList();
    },
    searchUser() {
      this.existUserCurrentPage = 1;
      this.queryUserList();
    },
    cropSuccess() {},
    cropUploadSuccess(jsonData) {
      this.detailsRuleForm.avatar = jsonData.result;
    },
    cropUploadFail() {},
    toggleShow() {
      this.show = !this.show;
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "用户账号(必填)",
          "用户姓名(必填)",
          "所属机构(必填)",
          "角色分配(必填)",
          "手机号(必填)",
          "工号"
        ];
        const data = [];

        exportJsonToExcel(tHeader, data, "职员模板");
      });
    },
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      let storeCode = this.$route.query.storeCode;
      console.log(storeCode)

      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let formatResult = [];
        result.forEach(v => {
          if (v[0]) {
            formatResult.push({
              username: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              realname: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
              departName: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
              roleName: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
              phone: v[4] ? (v[4] + "").replace(/\s*/g, "") : "",
              workNum: v[5] ? (v[5] + "").replace(/\s*/g, "") : "",
              storeCode: storeCode
            });
          }
        });

        console.log("formatResult", formatResult)

        that.$store
            .dispatch("batchImportEmployee", formatResult)
            .then(res => {
              const {code, result} = res;
              if (code === "0") {
                const { errList, succList } = result;
                console.log("errList:", errList);
                that.errEmployeeList = errList;
                that.succEmployeeList = succList;
                that.$message({
                  message: "操作成功",
                  type: "success"
                });
                if (errList && errList.length > 0) {
                  console.log(11111111)
                  that.errEmployeeVisible = true;
                }
              }
            });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    importf1(e){
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      let storeCode = this.$route.query.storeCode;
      console.log(storeCode);
      
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let formatResult = [];
        result.forEach(v => {
          if (v[0]) {
            formatResult.push({
              username: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              orgCode: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
              storeCode:storeCode
            });
          }
        });

        console.log("formatResult", formatResult)

        that.$store
            .dispatch("importEditUser", formatResult)
            .then(res => {
              console.log(res);
              const {code, result} = res;
              if (code === "0") {
                const errList = result;
                console.log("errList:", errList);
                that.errEmployeeList1 = errList;
                //that.succEmployeeList1 = succList;
                that.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.search();
                if (errList && errList.length > 0) {
                  console.log(11111111)
                  that.errEmployeeVisible1 = true;
                }
              }
            });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";

    },
    outputEmployeeErrExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "用户账号(必填)",
          "用户姓名(必填)",
          "所属机构(必填)",
          "角色分配(必填)",
          "手机号(必填)",
          "工号"
        ];
        const filterVal = [
          "username",
          "realname",
          "departName",
          "roleName",
          "phone",
          "workNum"
        ];
        const data = this.formatJson(filterVal, this.errEmployeeList);

        exportJsonToExcel(tHeader, data, "职员导入失败数据");
      });
    },
    outputEmployeeErrExcel1(){
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "用户账号(必填)",
          "机构编码(必填)",
          "错误原因"
        ];
        const filterVal = [
          "username",
          "orgcode",
          "error",
        ];
        const data = this.formatJson(filterVal, this.errEmployeeList1);

        exportJsonToExcel(tHeader, data, "修改职员组织导入失败数据");
      });
    },
    ruleSelecting(e) {
      console.log(e);
    }
  }
};
</script>
<style lang="scss" scoped>
.el-dropdown-link {
  border: 1px solid #d9d9d9;
  height: 30px;
  padding: 0 15px;
  border-radius: 3px;
}
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}

.pos {
  margin-right: 5px;
  width: 15px;
  height: 15px;
  line-height: 15px;
  background: #e50163;
  color: #fff;
}

.w50 {
  width: 50%;
}

.headPortrait-wrapper {
  width: 100px;
  height: 100px;
  border: 1px solid#dcdfe6;
  cursor: pointer;
  img {
    width: 100px;
  }
}
.el-input-number {
  width: 50px;
  margin: 0 8px;
  /deep/ .el-input {
    width: 100%;
    .el-input__inner {
      padding: 0 10px;
    }
  }
}
.ruleSetArea {
  margin-top: 22px;
  .ruleSetArea_title {
    font-size: 14px;
    color: #606266;
    font-weight: bold;
    width: 140px;
    text-align: right;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    label {
      position: relative;
      &:before {
        display: block;
        content: "";
        width: 3px;
        height: 14px;
        border-radius: 5px;
        background-color: #e50163;
        position: absolute;
        left: -8px;
        top: 2px;
      }
    }
  }
  .el-form {
    margin-top: 22px;
    /deep/ .el-input {
      width: 100px;
      margin: 0 8px;
    }
  }
}
</style>
